





















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import {
  DepositCollectionModelInAdmin,
  DepositCollectionWithModelInAdmin
} from '@/modules/deposit/models/deposit-collection.model'
import AdminDepositPayOffDialog from '@/modules/deposit/components/admin/pay-dialog/AdminDepositPayOffDialog.vue'
import { DepositStatus } from '@/modules/deposit/models/deposit-resource.model'
import { AdminDepositRoute } from '@/modules/deposit/routes/admin-deposit.route'

@Component({
  components: {
    BaseButton,
    ActionShowButton
  }
})
export default class AdminDepositActions extends Vue {

  constructor(
    private readonly routes: AdminDepositRoute
  ) {
    super()
  }

  @Prop() deposit!: DepositCollectionModelInAdmin
  @Prop() withData!: DepositCollectionWithModelInAdmin

  get showPageURL() {
    return this.routes.show(this.deposit.id)
  }

  get isPending() {
    return this.deposit.status === DepositStatus.PENDING
  }

  dialogShow() {
    this.$q.dialog({
      component: AdminDepositPayOffDialog,
      deposit: this.deposit,
      withData: this.withData
    })
  }
}

